import { render, staticRenderFns } from "./guidelines.vue?vue&type=template&id=128f0790&scoped=true"
import script from "./guidelines.vue?vue&type=script&lang=js"
export * from "./guidelines.vue?vue&type=script&lang=js"
import style0 from "./guidelines.vue?vue&type=style&index=0&id=128f0790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f0790",
  null
  
)

export default component.exports